<script lang="ts" setup>
    const { el = 'span' } = defineProps<{
        el?: string
    }>()
</script>

<template>
    <span>
        <svg width="9" height="9" viewBox="0 0 9 9" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M3.2998 0.699707H8.2998V5.79971" stroke="white" stroke-miterlimit="10" />
            <path d="M8.2998 0.699707L0.799805 8.29971" stroke="white" stroke-miterlimit="10" />
        </svg>
    </span>
</template>

<style scoped>
    span {
        position: relative;
        width: 13px;
        height: 12px;
        overflow: hidden;
        @apply transition-all;

        path {
            stroke: currentColor;
        }
    }
</style>
